// @ts-ignore
import websocketStore from 'svelte-websocket-store';
import { derived, get } from 'svelte/store';
import { WSKind } from '../data/websocket-kind.enum';
import { finished, gameState, getPlayer, setPlayer } from './game.store';
const initialValue = { kind: WSKind.Init };
const wsStore = websocketStore(' wss://quarto-online-server.herokuapp.com/', initialValue);
export const createWS = derived(wsStore, ($wsStore, set) => {
    if ($wsStore.kind === WSKind.Create) {
        set($wsStore);
    }
}, undefined);
export function create() {
    wsStore.set({ kind: WSKind.Create });
}
export const joinWS = derived(wsStore, ($wsStore, set) => {
    if ($wsStore.kind === WSKind.Join && !$wsStore.error) {
        set($wsStore);
    }
}, { kind: WSKind.Join, data: { success: false } });
joinWS.subscribe(({ data }) => {
    if (data.success) {
        requestState();
        setPlayer(data.player);
    }
});
export function join(roomKey) {
    wsStore.set({ kind: WSKind.Join, data: { roomKey } });
}
export const reqStateWS = derived(wsStore, ($wsStore, set) => {
    if ($wsStore.kind === WSKind.ReqState) {
        set($wsStore);
    }
}, undefined);
reqStateWS.subscribe((wsMsg) => {
    if (wsMsg) {
        sendState();
    }
});
export function requestState() {
    wsStore.set({ kind: WSKind.ReqState });
}
export const stateWS = derived(wsStore, ($wsStore, set) => {
    if ($wsStore.kind === WSKind.State) {
        set($wsStore);
    }
}, { kind: WSKind.State, data: null });
stateWS.subscribe(({ data }) => {
    if (data) {
        gameState.set(data);
    }
});
export function sendState() {
    wsStore.set({ kind: WSKind.State, data: get(gameState) });
}
export const winDeclarationWS = derived([wsStore, finished], ([$wsStore, $finished], set) => {
    if ($wsStore.kind === WSKind.Win && $wsStore.data.player !== getPlayer()) {
        set(true);
    }
    if ($finished) {
        set(false);
    }
}, false);
export function declareWin() {
    wsStore.set({ kind: WSKind.Win });
}
export const errorWS = derived(wsStore, ($wsStore, set) => {
    if ($wsStore.error) {
        set($wsStore);
    }
}, undefined);
